import axios from 'axios';
import { FilterSelectedValue } from '../hooks/filters/interfaces/filter-selected-value.interface';
const API_URL = process.env.REACT_APP_API_URL;

export const postScenarioPlanner = async <T>(
  name: string,
  description: string,
  filterSelection: FilterSelectedValue[],
): Promise<T> => {
  return (
    await axios.post(
      `${API_URL}scenario-planner`,
      { name, description, filterSelection },
      {},
    )
  ).data;
};

export const putScenarioPlanner = async <T>(
  id: string,
  name: string,
  description: string,
  filterSelection: FilterSelectedValue[],
): Promise<T> => {
  return (
    await axios.post(
      `${API_URL}scenario-planner`,
      { id, name, description, filterSelection },
      {},
    )
  ).data;
};

export const getScenarioPlanner = async <T>(id: string): Promise<T> => {
  return (await axios.get(`${API_URL}scenario-planner`, { params: { id } }))
    .data;
};

export const deleteScenarioPlanner = async <T>(id: string): Promise<T> => {
  return (await axios.delete(`${API_URL}scenario-planner`, { params: { id } }))
    .data;
};

export const postScenarioPlannerClone = async <T>(
  id: string,
  name: string,
  shareKey?: string,
): Promise<T> => {
  return (
    await axios.post(
      `${API_URL}scenario-planner-clone`,
      { id, name, shareKey },
      {},
    )
  ).data;
};

export const getScenarioPlanners = async <T>(): Promise<T> => {
  return (await axios.get(`${API_URL}scenario-planners`, { params: {} })).data;
};

export const postScenarioPlannerInput = async <T>(
  scenarioPlannerId: string,
  inputFields: any[],
  applyToFilterSelection: FilterSelectedValue[],
  updateIfZero: boolean,
  mode?: string,
): Promise<T> => {
  return (
    await axios.post(
      `${API_URL}scenario-planner-input`,
      {
        scenarioPlannerInputs: { scenarioPlannerId, inputFields, updateIfZero },
        applyToFilterSelection,
      },
      { params: { mode } },
    )
  ).data;
};

export const getScenarioPlannerInput = async <T>(
  filterSelection: FilterSelectedValue[],
): Promise<T> => {
  return (
    await axios.get(`${API_URL}scenario-planner-input`, {
      params: {},
      data: { filterSelection },
    })
  ).data;
};

export const postScenarioPlannerInputMode = async <T>(
  scenarioPlannerId: string,
  fields: any[],
): Promise<T> => {
  return (
    await axios.post(
      `${API_URL}scenario-planner-input-mode`,
      { scenarioPlannerInputMode: { scenarioPlannerId, fields } },
      {},
    )
  ).data;
};

export const postScenarioPlannerMainElasticity = async <T>(
  scenarioPlannerId: string,
  inputFields: any[],
  applyToFilterSelection: FilterSelectedValue[],
): Promise<T> => {
  return (
    await axios.post(
      `${API_URL}scenario-planner-input`,
      {
        scenarioPlannerInputs: {
          scenarioPlannerId,
          inputFields,
          updateIfZero: true,
        },
        applyToFilterSelection,
      },
      { params: { mode: 'main' } },
    )
  ).data;
};

export const postScenarioPlannerCrossElasticity = async <T>(
  scenarioPlannerId: string,
  inputFields: any[],
  applyToFilterSelection: FilterSelectedValue[],
): Promise<T> => {
  return (
    await axios.post(
      `${API_URL}scenario-planner-input`,
      {
        scenarioPlannerInputs: {
          scenarioPlannerId,
          inputFields,
        },
        applyToFilterSelection,
      },
      { params: { mode: 'cross' } },
    )
  ).data;
};
